import { useState, useEffect } from 'react';
import { GetNamedFeatureFlag, ModifyFeatureFlag } from '../../api/Api';
import { useForm, FormProvider } from "react-hook-form";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { modifiedFeatureFlag } from '../../Models/ModifyFeatureFlagRequest'
import { authCredentials } from '../../Models/AuthCredentials';
import CredentialComponent from './CredentialComponent';
import Card from '../Card/Card';
import '../../App.css'

function EditFeatureFlagForm(props){

    const [featureFlagData, setFeatureFlagData] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const [alertData, setAlertData] = useState({});
    const [isEnabledForAllChecked, setEnabledForAllChecked] = useState(false);

    const methods = useForm();
    const { handleSubmit, register, reset, formState, setValue } = methods;
    const { dirtyFields } = formState;

    useEffect(() => {
        GetNamedFeatureFlag(props.serviceName, props.featureFlagName).then(
            (res) =>  
            {
                let flag = cleanAndSetFeatureFlag(res.data);
                setFeatureFlagData(flag);
                setEnabledForAllChecked(flag.enabledFor["enabledForAll"] === 'True' ? true: false);
            });
    }, [props.serviceName, props.featureFlagName, isEnabledForAllChecked]);

    useEffect(() =>{
        if (featureFlagData === undefined || featureFlagData.enabledFor === undefined || featureFlagData.enabledFor["enabledForAll"] === undefined){
            setEnabledForAllChecked(false);
        } else{
            setEnabledForAllChecked(featureFlagData.enabledFor["enabledForAll"] === 'True' ? true: false)
            setValue('enabledForAll', isEnabledForAllChecked) //sets the default checkbox value in the form
        }
    },[featureFlagData, isEnabledForAllChecked, setValue])

    async function onSubmit(data){
        let modifiedFlag = new modifiedFeatureFlag(
            dirtyFields.flagDescription === true? data.flagDescription : featureFlagData.featureFlagDescription, 
            dirtyFields.enabledForAll === true? data.enabledForAll : isEnabledForAllChecked, 
            data.username, 
            featureFlagData.FeatureFlagName, 
            featureFlagData.ServiceName);

        let credentials = new authCredentials(data.username, data.password);
        let updatedFlagData = {...featureFlagData};
        updatedFlagData.featureFlagDescription = modifiedFlag.flagDescription;
        updatedFlagData.enabledFor.enabledForAll = modifiedFlag.enabledForAll;

        try {
            let response = await ModifyFeatureFlag(modifiedFlag, credentials);;
            handleResponse(response);
            setFeatureFlagData(updatedFlagData);
            setEnabledForAllChecked(updatedFlagData.enabledFor.enabledForAll);
            reset();
        } catch (err) {
            handleResponse(err.response);
        }
    }

    function handleResponse(response){
        if (response.status === 200){
            setShowAlert(true);
            let data = {
                variant:'primary', 
                heading:`Request status: ${response.status}`, 
                message:response="The Flag has been modified successfully"
            }
            setAlertData(data);
        } else if (response.status === 400){
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:"Invalid Login"
            }
            setAlertData(data);
        }
        else if (response.status === 401){
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:"User is not authorized"
            }
            setAlertData(data);
        } else {
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:response=response.data.Message
            }
            setAlertData(data);
        }
    }

    return (
    <section >
        <FormProvider {...methods} >
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group>
                    <Form.Label>FeatureFlagName</Form.Label>
                    <Form.Control type='text' name="flagName" readOnly {...register('flagName')} defaultValue={featureFlagData.FeatureFlagName}/>
                </Form.Group>
                <Form.Group>
                    <Form.Label>ServiceName</Form.Label>
                    <Form.Control type='text' name="serviceName" readOnly {...register('serviceName')} defaultValue={featureFlagData.ServiceName}/>
                </Form.Group>
                <Form.Group>
                    <Form.Label>FeatureFlagDescription</Form.Label>
                    <Form.Control type='text' name="flagDescription" required {...register('flagDescription')} defaultValue={featureFlagData.featureFlagDescription}/>
                </Form.Group>
                <Form.Group>
                    <Form.Check type='checkbox' name="enabledForAll" {...register('enabledForAll')} label="EnabledForAll"/>
                </Form.Group>
                <CredentialComponent />
                <Button variant="secondary" type='submit'>Submit</Button>
            </Form>
        </FormProvider>
        <br />
        <Card show={showAlert} variant={alertData.variant} heading={alertData.heading} message={alertData.message}></Card>
    </section>);
}

function cleanAndSetFeatureFlag(flag){
    let flagString = flag.enabledFor.toString();
    let valid = flagString.replaceAll(/'/g, '"');
    flag.enabledFor = JSON.parse(valid);

    return flag;
}

export default EditFeatureFlagForm;